import { Divider } from "antd";
import React, {useEffect, useRef, ReactElement} from "react";

import {Researcher} from "../../utils/types";
import { allBeforeCurrentYear, getRidOfOutdatedYears } from "utils/restrictYears";


interface Props {
    researcher: Researcher
}

const ProfileDescriptionBasicInfo = ({researcher}: Props) => {
    const profileDescriptionRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (researcher.show_description && researcher.description) {
            if (profileDescriptionRef?.current) {
                profileDescriptionRef.current.innerHTML = researcher.description;
            }
        }
    }, [researcher]);

    const basicInfo = researcher && (
        <>
            <Divider />
            {researcher.recruitment.accepting_graduate_student &&
             (!allBeforeCurrentYear(researcher.recruitment.years)) &&
            <>
                <h2 className="sub-heading-font">
                    <strong>{
                        'Accepting Graduate Students'+
                        (
                            getRidOfOutdatedYears(researcher.recruitment.years).length===0?'':
                            ` for: ${getRidOfOutdatedYears(researcher.recruitment.years).join(', ')}`
                        )
                    }</strong>
                </h2>
                {researcher.recruitment.note &&
                <p>
                    {researcher.recruitment.note}
                </p>}
            </>}
            
            {researcher.show_description && researcher.description && <>
                <h2 className="sub-heading-font">
                    <strong>Research Description</strong>
                </h2>
                <div ref={profileDescriptionRef}></div>
            </>}

            {researcher.show_languages && researcher.languages && <>
                <h2 className="sub-heading-font">
                    <strong>Languages</strong>
                </h2>
                <p>{researcher.languages.join(', ')}</p>
            </>}
        </>
    )

    return basicInfo as ReactElement;
}

export default ProfileDescriptionBasicInfo;